import { Theme } from '@eversports/react-components/design-tokens/theme'
import { AccordionDetails } from '@eversports/react-components/primitives/Accordion'
import { VerticalFlex } from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  details: {
    marginLeft: theme.spacing(4),
    marginTop: theme.layoutSpacing.dense,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      padding: 0,
    },
  },
}))

const PaymentMethodExpansionPanelDetails: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const classes = useStyles()

  return (
    <AccordionDetails className={classes.root}>
      <VerticalFlex verticalSpacing="default" className={classes.details}>
        {children}
      </VerticalFlex>
    </AccordionDetails>
  )
}

export default PaymentMethodExpansionPanelDetails
